/**
 * Users API module
 */
import { fetchApi } from './client';
import { MUTATION_TIMEOUT_MS } from './requestTimeout';

export interface UserProfile {
  id: string;
  email: string;
  name: string;
  avatarUrl: string | null;
}

export const usersApi = {
  updateProfile: (token: string | undefined, userId: string, data: { name: string }) =>
    fetchApi<UserProfile>(`/users/${userId}`, {
      token,
      method: 'PATCH',
      timeoutMs: MUTATION_TIMEOUT_MS,
      body: JSON.stringify(data),
    }),
};
